import moment from 'moment'

export default function(val) {
    return val != null ? moment(val).locale("pt-br").format('DD/MM/YYYY HH:mm:ss') : null
}; 